import { TableCell, TableRow } from '@mui/material'
import React from 'react'

const MyTableNotFound = ({ text, columns }) => {
  return (
    <TableRow>
        <TableCell
            colSpan={columns ? columns : '100%'}
        >
            <p className='myTable__notFound'>
                {
                    text
                }
            </p>
        </TableCell>
    </TableRow>
  )
}

export default MyTableNotFound